import React from 'react'
import WallarmMappingForm from './WallarmMappingForm';
import WallarmCredentialForm from './WallarmCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function WallarmConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={WallarmMappingForm}
            CredentialsForm={WallarmCredentialForm}
            componentName="Node Name"
            componentKey="nodeName"
        />
    )
}